if (!customElements.get('dink-sticky-cart')) {
  customElements.define('dink-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.shopify-section');
      this.button = this.querySelector('[data-dink-submit]');
      if (!this.root || !this.button) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.sync = this.sync.bind(this);
      this.button.addEventListener('click', () => {
        if (this.button.disabled || this.locked) return; // prevents duplicate submissions
        this.locked=true; setTimeout(()=>{this.locked=false;},900);
        const size = this.root.querySelector('[data-is-size-option="true"]');
        if (this.missingSize()) {
          size.scrollIntoView({behavior:'smooth',block:'center'});
          const control = size.querySelector('input:not(:disabled),select');
          control?.focus({preventScroll:true});
          this.locked=false;
          return;
        }
        const native = this.nativeButton();
        if (native && !native.disabled) native.click();
      }, {signal});
      this.root.addEventListener('change', () => requestAnimationFrame(this.sync), {signal});
      this.root.addEventListener('variant:selected', () => {this.loading=true;this.sync();}, {signal});
      this.root.addEventListener('variant:update', () => {
        this.loading=false;
        requestAnimationFrame(this.sync);
      }, {signal});
      this.root.addEventListener('cart:update', (event) => {
        if (String(event.detail?.data?.productId) !== this.dataset.productId || event.detail?.data?.didError) return;
        this.added=true;
        this.querySelector('[data-dink-status]').textContent=this.dataset.added;
        this.sync();
        clearTimeout(this.timer);
        this.timer=setTimeout(()=>{this.added=false;this.sync();},2500);
      }, {signal});
      this.root.addEventListener('cart:error', ()=>{this.added=false;this.sync();}, {signal});
      const content=this.root.querySelector('#gen-product-information');
      this.mutations=new MutationObserver(()=>requestAnimationFrame(this.sync));
      if(content)this.mutations.observe(content,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled']});
      this.hidden=true;
      this.visibilityFrame=0;
      this.updateVisibility=()=>{
        if(this.visibilityFrame)return;
        this.visibilityFrame=requestAnimationFrame(()=>{
          this.visibilityFrame=0;
          const native=this.nativeButton();
          const rect=native?.getBoundingClientRect();
          // Show only after the original button has fully scrolled above the viewport.
          // A button below the fold must never reveal the sticky bar.
          const viewportTop=window.visualViewport?.offsetTop||0;
          const passed=!!rect && rect.width>0 && rect.height>0 && rect.bottom<=viewportTop;
          this.hidden=!passed;
        });
      };
      window.addEventListener('scroll',this.updateVisibility,{signal,passive:true});
      window.addEventListener('resize',this.updateVisibility,{signal,passive:true});
      window.addEventListener('orientationchange',this.updateVisibility,{signal});
      window.visualViewport?.addEventListener('resize',this.updateVisibility,{signal});
      this.intersection=new IntersectionObserver(this.updateVisibility,{threshold:0});
      this.observeNative=()=>{
        const native=this.nativeButton();
        if(native!==this.observedNative){
          if(this.observedNative)this.intersection.unobserve(this.observedNative);
          this.observedNative=native;
          if(native)this.intersection.observe(native);
        }
        this.updateVisibility();
      };
      this.sync();
    }
    nativeButton() {return this.root.querySelector('product-form-component [ref="addToCartButton"]');}
    missingSize() {
      const size=this.root.querySelector('[data-is-size-option="true"]');
      return !!size && !size.querySelector('input:checked') && !size.querySelector('select')?.value;
    }
    sync() {
      const native=this.nativeButton();
      if(!native){this.hidden=true;return;}
      this.observeNative();
      const missing=this.missingSize();
      const price=this.root.querySelector('product-price .price');
      if(price)this.querySelector('[data-dink-price]').textContent=price.textContent.trim();
      const selected=[...this.root.querySelectorAll('variant-picker input[type="radio"]:checked,variant-picker select')].map(el=>el.value).filter(Boolean);
      this.querySelector('[data-dink-variant]').textContent=selected.join(' / ');
      this.button.disabled=!missing && (this.loading || native.disabled);
      this.button.textContent=missing?this.dataset.select:this.loading?this.dataset.loading:this.added?this.dataset.added:native.disabled?native.innerText.trim():this.dataset.add;
    }
    disconnectedCallback() {this.controller?.abort();this.mutations?.disconnect();this.intersection?.disconnect();clearTimeout(this.timer);cancelAnimationFrame(this.visibilityFrame);}
  });
}
